export default "__VITE_ASSET__D74bCVD4__"